import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import AccountItem from 'web-app/react/entities/account-items/model';
import Table from 'web-app/react/components/table/model';

export const moveInvoice = (institutionId, billPayerId, invoiceId, newBillPayerId) => {
    return RESTClient.postAuthenticated(`v2/invoicing/${institutionId}/${billPayerId}/invoices/${invoiceId}/move`, {
        newBillPayerId,
    });
};

export const resendInvoice = (institutionId, billPayerId, invoiceId) => {
    return RESTClient.postAuthenticated(`v2/invoicing/${institutionId}/${billPayerId}/invoices/${invoiceId}/resend`);
};

export const cancelInvoice = (institutionId, billPayerId, invoiceId, notify, creditNoteDate) => {
    const data = {
        notify,
        date: creditNoteDate,
    };

    return RESTClient.postAuthenticated(
        `v2/invoicing/${institutionId}/${billPayerId}/invoices/${invoiceId}/credit`,
        data,
    );
};

export const fetchSingleInvoice = invoiceId => {
    return RESTClient.getAuthenticatedObservable(`v2/invoicing/invoices/${invoiceId}`).map(response => ({
        invoice: AccountItem.fromAPI(response.invoice),
    }));
};

export const fetchDetails = invoiceId => {
    return RESTClient.getAuthenticatedObservable(`v2/invoicing/invoices/${invoiceId}/details`).map(response => ({
        children: List(response.children).map(({child, tables}) => ({
            child,
            tables: List(tables).map(table => Table.fromAPI(table)),
        })),
    }));
};
